import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface ChatItemMetaProps {
  children: ReactNode;
}

export function ChatItemMeta({ children }: ChatItemMetaProps) {
  return (
    <Box className="ChatMeta" flex="1" overflow="hidden">
      {children}
    </Box>
  );
}
